import React, { useState, useEffect } from "react";
import { getVideoById } from "../../../../services/Faqs&Resourse/resource";
import { constants, DateFormat } from "../../../Constants/commenFeatures";
import Footer from "../../Footer";

const VideoDetail = (props) => {
  const id = props.match.params.resourceId;

  const [customResouces, setCustomResouces] = useState("");

  const getResoucesRes = (res) => {
    if (res && res.data) {
      setCustomResouces(res.data);
    }
  };

  useEffect(() => {
    getVideoById(getResoucesRes, id);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="articleDetail-container">
          <div className="back_btn">
            <i class="edel-icon-arrow-left"></i>
            <span onClick={() => props.history.goBack()}>Back</span>
          </div>
          <div className="artical_page">
            {customResouces !== "" && (
              <div className="articleWraps artical_page_wrap no_border">
                <div className="vid_banner">
                  <iframe
                    src={customResouces.url}
                    title="YouTube video player"
                    frameborder="0"
                    allow="fullscreen"
                    allowfullscreen
                  ></iframe>
                </div>
                <div>
                  <div className="infos">
                    <h2>{customResouces.name}</h2>
                  </div>
                  <div className="display-flex align-center articleWrapsInfo">
                    <p className="date">
                      {DateFormat(
                        customResouces.date,
                        constants.resourceDateFormat
                      )}
                    </p>
                  </div>
                </div>
              </div>
            )}
            {/* <div className="nextArtcalBtn">
              <span>
                Read next artical <i className="edel-icon-arrow-right"></i>
              </span>
            </div> */}
            <div className="tradingAlgos"></div>
            {/* <div>
        <div className="resouces_btn_section align_left">
          <p>Search for topics related to</p>
          <SearchBtnGroup />
        </div>
      </div> */}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default VideoDetail;
